module.exports = __webpack_public_path__ + "static/media/metamask_01.fdfa1135.png";